var _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _path8, _path9, _path10, _path11, _circle2, _path12, _path13, _path14, _path15, _path16, _circle3, _path17, _path18, _path19, _path20, _path21, _circle4, _path22, _path23, _polygon, _path24, _polygon2, _path25, _circle5, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdateService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 437.37008,
    height: 777.68742,
    viewBox: "0 0 437.37008 777.68742",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M720.54168,790.67639H488.45428a64.40159,64.40159,0,0,1-64.40186-64.40186V125.30041a64.47489,64.47489,0,0,1,64.40186-64.40185H720.5407a64.47493,64.47493,0,0,1,64.4021,64.40185V233.84582h3.99878V313.8219H784.9428V726.27453a64.402,64.402,0,0,1-64.40112,64.40186ZM488.45428,62.89856a62.47244,62.47244,0,0,0-62.40186,62.40185V726.27453A62.4011,62.4011,0,0,0,488.454,788.67639H720.5407A62.40192,62.40192,0,0,0,782.9428,726.275V311.8219h3.99878V235.84582H782.9428V125.30041a62.47244,62.47244,0,0,0-62.40185-62.40185Z",
    transform: "translate(-380.85104 -60.89856)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M723.09807,774.18274H489.89812A48.40576,48.40576,0,0,1,441.548,725.83313V125.74279A48.40617,48.40617,0,0,1,489.89812,77.3927h29.77662l-.56031,1.37695a21.50684,21.50684,0,0,0,19.9043,29.61328H671.978a21.507,21.507,0,0,0,19.90381-29.61328l-.56031-1.37695h31.77661a48.40614,48.40614,0,0,1,48.34986,48.35009V725.83313A48.40541,48.40541,0,0,1,723.09807,774.18274ZM489.89812,79.3927A46.40372,46.40372,0,0,0,443.548,125.74279V725.83313a46.40362,46.40362,0,0,0,46.35009,46.34961h233.2a46.40328,46.40328,0,0,0,46.34986-46.34961V125.74279h0A46.40369,46.40369,0,0,0,723.09807,79.3927H694.24578a23.5077,23.5077,0,0,1-22.26709,30.99023H539.018A23.50811,23.50811,0,0,1,516.74993,79.3927Z",
    transform: "translate(-380.85104 -60.89856)",
    fill: "#ccc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M797.09814,451.66484H401.974a21.14681,21.14681,0,0,1-21.123-21.123V303.80393a21.14681,21.14681,0,0,1,21.123-21.123H797.09814a21.1468,21.1468,0,0,1,21.123,21.123V430.54185A21.1468,21.1468,0,0,1,797.09814,451.66484Z",
    transform: "translate(-380.85104 -60.89856)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M797.09814,451.66484H401.974a21.14681,21.14681,0,0,1-21.123-21.123V303.80393a21.14681,21.14681,0,0,1,21.123-21.123H797.09814a21.1468,21.1468,0,0,1,21.123,21.123V430.54185A21.1468,21.1468,0,0,1,797.09814,451.66484ZM401.974,285.166a18.65909,18.65909,0,0,0-18.63793,18.63793V430.54185A18.65909,18.65909,0,0,0,401.974,449.17978H797.09814a18.65909,18.65909,0,0,0,18.63792-18.63793V303.80393A18.65909,18.65909,0,0,0,797.09814,285.166Z",
    transform: "translate(-380.85104 -60.89856)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M651.35072,360.339H513.43005a9.94023,9.94023,0,0,1,0-19.88046H651.35072a9.94023,9.94023,0,0,1,0,19.88046Z",
    transform: "translate(-380.85104 -60.89856)",
    fill: "#6c63ff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M779.33117,393.88726H513.43005a9.94023,9.94023,0,0,1,0-19.88046H779.33117a9.94023,9.94023,0,0,1,0,19.88046Z",
    transform: "translate(-380.85104 -60.89856)",
    fill: "#6c63ff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 66.22588,
    cy: 306.27433,
    r: 37.27586,
    fill: "#6c63ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M779.31643,434.26944h-34.7908a9.94023,9.94023,0,1,1,0-19.88046h34.7908a9.94023,9.94023,0,1,1,0,19.88046Z",
    transform: "translate(-380.85104 -60.89856)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M779.31643,434.26944h-34.7908a9.94023,9.94023,0,1,1,0-19.88046h34.7908a9.94023,9.94023,0,1,1,0,19.88046Z",
    transform: "translate(-380.85104 -60.89856)",
    fill: "#ccc"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M719.46745,250.18756H499.60471A11.76692,11.76692,0,0,1,487.851,238.4339v-70.522a11.76692,11.76692,0,0,1,11.75367-11.75366H719.46745a11.76692,11.76692,0,0,1,11.75367,11.75366v70.522A11.76692,11.76692,0,0,1,719.46745,250.18756ZM499.60471,157.541a10.38265,10.38265,0,0,0-10.37088,10.37088v70.522a10.38265,10.38265,0,0,0,10.37088,10.37088H719.46745a10.38266,10.38266,0,0,0,10.37089-10.37088v-70.522A10.38266,10.38266,0,0,0,719.46745,157.541Z",
    transform: "translate(-380.85104 -60.89856)",
    fill: "#ccc"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M638.36781,199.37023H561.62326a5.53114,5.53114,0,0,1,0-11.06227h76.74455a5.53114,5.53114,0,0,1,0,11.06227Z",
    transform: "translate(-380.85104 -60.89856)",
    fill: "#e6e6e6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M709.58121,218.03782h-147.958a5.53114,5.53114,0,0,1,0-11.06227h147.958a5.53114,5.53114,0,1,1,0,11.06227Z",
    transform: "translate(-380.85104 -60.89856)",
    fill: "#e6e6e6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 143.85071,
    cy: 142.27433,
    r: 20.74177,
    fill: "#e6e6e6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M709.573,240.50807H690.214a5.53114,5.53114,0,1,1,0-11.06227h19.359a5.53114,5.53114,0,0,1,0,11.06227Z",
    transform: "translate(-380.85104 -60.89856)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M709.573,240.50807H690.214a5.53114,5.53114,0,1,1,0-11.06227h19.359a5.53114,5.53114,0,0,1,0,11.06227Z",
    transform: "translate(-380.85104 -60.89856)",
    fill: "#ccc"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M719.46745,576.18756H499.60471A11.76692,11.76692,0,0,1,487.851,564.4339v-70.522a11.76692,11.76692,0,0,1,11.75367-11.75366H719.46745a11.76692,11.76692,0,0,1,11.75367,11.75366v70.522A11.76692,11.76692,0,0,1,719.46745,576.18756ZM499.60471,483.541a10.38265,10.38265,0,0,0-10.37088,10.37088v70.522a10.38265,10.38265,0,0,0,10.37088,10.37088H719.46745a10.38266,10.38266,0,0,0,10.37089-10.37088v-70.522A10.38266,10.38266,0,0,0,719.46745,483.541Z",
    transform: "translate(-380.85104 -60.89856)",
    fill: "#ccc"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M638.36781,525.37023H561.62326a5.53113,5.53113,0,0,1,0-11.06227h76.74455a5.53114,5.53114,0,0,1,0,11.06227Z",
    transform: "translate(-380.85104 -60.89856)",
    fill: "#e6e6e6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M709.58121,544.03782h-147.958a5.53114,5.53114,0,0,1,0-11.06227h147.958a5.53113,5.53113,0,1,1,0,11.06227Z",
    transform: "translate(-380.85104 -60.89856)",
    fill: "#e6e6e6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 143.85071,
    cy: 468.27433,
    r: 20.74177,
    fill: "#e6e6e6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M709.573,566.50807H690.214a5.53113,5.53113,0,1,1,0-11.06227h19.359a5.53114,5.53114,0,0,1,0,11.06227Z",
    transform: "translate(-380.85104 -60.89856)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M709.573,566.50807H690.214a5.53113,5.53113,0,1,1,0-11.06227h19.359a5.53114,5.53114,0,0,1,0,11.06227Z",
    transform: "translate(-380.85104 -60.89856)",
    fill: "#ccc"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M719.46745,707.18756H499.60471A11.76692,11.76692,0,0,1,487.851,695.4339v-70.522a11.76692,11.76692,0,0,1,11.75367-11.75366H719.46745a11.76692,11.76692,0,0,1,11.75367,11.75366v70.522A11.76692,11.76692,0,0,1,719.46745,707.18756ZM499.60471,614.541a10.38265,10.38265,0,0,0-10.37088,10.37088v70.522a10.38265,10.38265,0,0,0,10.37088,10.37088H719.46745a10.38266,10.38266,0,0,0,10.37089-10.37088v-70.522A10.38266,10.38266,0,0,0,719.46745,614.541Z",
    transform: "translate(-380.85104 -60.89856)",
    fill: "#ccc"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M638.36781,656.37023H561.62326a5.53113,5.53113,0,0,1,0-11.06227h76.74455a5.53114,5.53114,0,0,1,0,11.06227Z",
    transform: "translate(-380.85104 -60.89856)",
    fill: "#e6e6e6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M709.58121,675.03782h-147.958a5.53114,5.53114,0,0,1,0-11.06227h147.958a5.53113,5.53113,0,1,1,0,11.06227Z",
    transform: "translate(-380.85104 -60.89856)",
    fill: "#e6e6e6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 143.85071,
    cy: 599.27433,
    r: 20.74177,
    fill: "#e6e6e6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M709.573,697.50807H690.214a5.53113,5.53113,0,1,1,0-11.06227h19.359a5.53114,5.53114,0,0,1,0,11.06227Z",
    transform: "translate(-380.85104 -60.89856)",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M709.573,697.50807H690.214a5.53113,5.53113,0,1,1,0-11.06227h19.359a5.53114,5.53114,0,0,1,0,11.06227Z",
    transform: "translate(-380.85104 -60.89856)",
    fill: "#ccc"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "201.657 765.803 213.917 765.803 219.749 718.515 201.655 718.516 201.657 765.803",
    fill: "#ffb8b8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M579.38069,822.69926l24.1438-.001h.001a15.38605,15.38605,0,0,1,15.38647,15.38623v.5l-39.53051.00147Z",
    transform: "translate(-380.85104 -60.89856)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "152.657 765.803 164.917 765.803 170.749 718.515 152.655 718.516 152.657 765.803",
    fill: "#ffb8b8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M530.38069,822.69926l24.1438-.001h.001a15.38605,15.38605,0,0,1,15.38647,15.38623v.5l-39.53051.00147Z",
    transform: "translate(-380.85104 -60.89856)",
    fill: "#2f2e41"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.10389,
    cy: 413.86127,
    r: 24.56103,
    fill: "#ffb8b8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M601.47137,816.49572H578.72063a4.50027,4.50027,0,0,1-4.49951-4.55468l1.322-108.03125a1.50006,1.50006,0,0,0-2.989-.2002L559.31341,812.53967a4.50405,4.50405,0,0,1-4.467,3.95605H531.87713a4.49963,4.49963,0,0,1-4.48633-4.85058l15.16748-194.0752.41235-.04492,72.62891-7.84375-9.63306,202.52832A4.49485,4.49485,0,0,1,601.47137,816.49572Z",
    transform: "translate(-380.85104 -60.89856)",
    fill: "#2f2e41"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M543.44231,629.484a4.49627,4.49627,0,0,1-4.48388-4.3584c-.39649-12.27149-1.07593-54.73242,6.822-85.90528a40.92361,40.92361,0,0,1,37.79272-30.83886h0a41.17944,41.17944,0,0,1,40.5586,26.02343c13.27539,33.70313,25.81787,75.2461,10.1809,81.76172-20.49487,8.53907-74.52343,12.34571-90.59423,13.3086Q543.57965,629.484,543.44231,629.484Z",
    transform: "translate(-380.85104 -60.89856)",
    fill: "#6c63ff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M637.3136,449.93578a10.52493,10.52493,0,0,0,1.246,1.09311l-2.57824,49.52618-10.72422,5.49051,6.17078,17.26776,19.92971-7.87486a8,8,0,0,0,5.0258-8.18054l-5.22115-56.17947a10.4971,10.4971,0,1,0-13.84864-1.14269Z",
    transform: "translate(-380.85104 -60.89856)",
    fill: "#ffb8b8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M636.18482,502.39862l7.54416,21.43891a4.5,4.5,0,0,1-3.38906,5.91156l-22.24542,4.30782a12.49741,12.49741,0,0,1-8.22761-23.60176l19.97367-10.543a4.5,4.5,0,0,1,6.34426,2.48649Z",
    transform: "translate(-380.85104 -60.89856)",
    fill: "#6c63ff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M530.927,449.93578a10.52563,10.52563,0,0,1-1.24595,1.09311l2.57824,49.52618,10.72421,5.49051-6.17078,17.26776L516.883,515.43848a8,8,0,0,1-5.0258-8.18054l5.22116-56.17947a10.4971,10.4971,0,1,1,13.84863-1.14269Z",
    transform: "translate(-380.85104 -60.89856)",
    fill: "#ffb8b8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M534.65883,499.70259a4.4952,4.4952,0,0,1,3.7412.20954l19.97367,10.543a12.49741,12.49741,0,0,1-8.22761,23.60176l-22.24543-4.30782a4.5,4.5,0,0,1-3.38906-5.91156l7.54417-21.43891A4.495,4.495,0,0,1,534.65883,499.70259Z",
    transform: "translate(-380.85104 -60.89856)",
    fill: "#6c63ff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M594.49418,478.94639a16.14324,16.14324,0,0,1,9.04057-15.16764c7.46589-3.85407,12.156-12.07516,10.10083-19.5821-2.63064-9.60888-15.70861-15.84073-26.30516-12.53479a48.56536,48.56536,0,0,0-8.26083,3.83933l-6.9231,3.711a71.72652,71.72652,0,0,0-8.534,5.03785A28.31536,28.31536,0,0,0,552.34221,470.78c1.36337,9.76869,7.7607,18.72745,16.51766,24.861a27.93669,27.93669,0,0,0,11.3188,5.03109c4.19751.692,8.87033-.09445,11.93939-2.70479,4.79626-4.07938,4.30076-10.91073,2.74952-16.61636A12.09016,12.09016,0,0,1,594.49418,478.94639Z",
    transform: "translate(-380.85104 -60.89856)",
    fill: "#2f2e41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateService);
export default __webpack_public_path__ + "static/media/updateService.d6641084e16f81d54a891e663aeda05a.svg";
export { ForwardRef as ReactComponent };